var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "changebookingdetails"
  }, [_c('b-card', [(!_vm.parentObj) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Change Booking Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })])])]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (!_vm.parentObj) ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Shipment ID")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Shipment ID",
      "id": "shippingid",
      "placeholder": "Please Enter Shipment ID",
      "maxlength": 16
    },
    domProps: {
      "value": (_vm.shippingid)
    },
    on: {
      "keyup": _vm.selectCheckbox,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Shipment ID')),
      expression: "errors.has('Shipment ID')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Shipment ID')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Clear")])])], 1)])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "otherinformation"
  }, [_c('b-card', [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "PickupLocation",
      "id": "chck1",
      "disabled": _vm.subtabdisabledflag
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Change Pickup Location")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "pickuplocationform"
    }
  }, [_c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentDropByClient),
      expression: "ShipmentDropByClient"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ShipmentDropByClient",
      "name": "ShipmentDropByClient",
      "disabled": _vm.selfcollect
    },
    domProps: {
      "checked": Array.isArray(_vm.ShipmentDropByClient) ? _vm._i(_vm.ShipmentDropByClient, "1") > -1 : (_vm.ShipmentDropByClient)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ShipmentDropByClient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ShipmentDropByClient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ShipmentDropByClient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ShipmentDropByClient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("Shipment drop to hub by client   "), _c('span', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.checkhover
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "title": "This shipment has to be dropped at origin branch by consignor"
    }
  })])]), _vm._v(" "), _c('small', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tooltip"
    }
  }, [_vm._v("\n                              This shipment has to be dropped at origin branch by consignor\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.ShipmentDropByClient == false) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Location Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LocationName),
      expression: "LocationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "LocationName",
      "id": "LocationName",
      "placeholder": "Enter Location Name",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.LocationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.LocationName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.LocationName')),
      expression: "errors.has('pickuplocationform.LocationName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Location Name field is required")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Mobile),
      expression: "Mobile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:10'),
      expression: "'required|numeric|digits:10'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Mobile",
      "id": "Mobile",
      "placeholder": "Enter Mobile Number",
      "maxlength": "10",
      "pattern": "^[6789](\\d)(?!\\1+$){3,}\\d{8}$"
    },
    domProps: {
      "value": (_vm.Mobile)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Mobile')),
      expression: "errors.has('pickuplocationform.Mobile')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Mobile')))]), _vm._v(" "), (_vm.errors.first('pickuplocationform.Mobile') == 'The Mobile field format is invalid') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Number Should Start with 6,7,8 or 9")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Telephone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Telephone),
      expression: "Telephone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Telephone",
      "id": "Telephone",
      "placeholder": "Enter Telephone",
      "maxlength": "12",
      "minlength": "6"
    },
    domProps: {
      "value": (_vm.Telephone)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Telephone')),
      expression: "errors.has('pickuplocationform.Telephone')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Telephone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Email")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Email),
      expression: "Email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Enter Email",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Email')),
      expression: "errors.has('pickuplocationform.Email')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Email')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.ShipmentDropByClient == false) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Address),
      expression: "Address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "Address",
      "name": "Address",
      "placeholder": "Address ",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Address')),
      expression: "errors.has('pickuplocationform.Address')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Address')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      }
    }
  }, [_vm._v("GST No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GstNo),
      expression: "GstNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validate_gst'),
      expression: "'required|validate_gst'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "GstNo",
      "id": "GstNo",
      "placeholder": "Enter GST NO. "
    },
    domProps: {
      "value": (_vm.GstNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GstNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "gstBlock"
    }
  }, [_vm._v("Note: Allowed GST Format 00XXXXX0000X1ZZ.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.GstNo')),
      expression: "errors.has('pickuplocationform.GstNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.GstNo')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Comments")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupcomments),
      expression: "pickupcomments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pickupcomments')
    },
    attrs: {
      "name": "pickupcomments",
      "id": "pickupcomments",
      "placeholder": "Enter Comments",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.pickupcomments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupcomments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.pickupcomments')),
      expression: "errors.has('pickuplocationform.pickupcomments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter comment")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      },
      "click": _vm.checkPickupLocationValidation
    }
  }, [_vm._v("Save")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ConsigneeLocation",
      "id": "chck2",
      "disabled": _vm.subtabdisabledflag
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Change Consignee Location")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "consigneedetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SelfCollectByClient),
      expression: "SelfCollectByClient"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "SelfCollectByClient",
      "name": "SelfCollectByClient",
      "disabled": _vm.selfdrop
    },
    domProps: {
      "checked": Array.isArray(_vm.SelfCollectByClient) ? _vm._i(_vm.SelfCollectByClient, "1") > -1 : (_vm.SelfCollectByClient)
    },
    on: {
      "click": _vm.ChkCollectByClient,
      "__c": function($event) {
        var $$a = _vm.SelfCollectByClient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.SelfCollectByClient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.SelfCollectByClient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.SelfCollectByClient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("Self collect by client "), _c('span', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.checkhover
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "title": "This shipment has to be collected by receiver from destination branch"
    }
  })])]), _vm._v(" "), _c('small', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tooltip"
    }
  }, [_vm._v("This shipment has to be collected by receiver from destination branch")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.SelfCollectByClient == false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AddNewConsigneeFlag == true),
      expression: "AddNewConsigneeFlag==true"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignee Code")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConsigneeCode),
      expression: "ConsigneeCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.AddNewConsigneeFlag == true ? 'required' : ''))),
      expression: "`${AddNewConsigneeFlag == true ? 'required' : ''}`"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ConsigneeCode",
      "id": "ConsigneeCode",
      "placeholder": "Enter Consignee Code",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.ConsigneeCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConsigneeCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ConsigneeCode')),
      expression: "errors.has('consigneedetailsform.ConsigneeCode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Consignee Code field is required")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Company Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building-o ' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompanyName),
      expression: "CompanyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "CompanyName",
      "id": "CompanyName",
      "placeholder": "Enter Company Name ",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.CompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CompanyName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.CompanyName')),
      expression: "errors.has('consigneedetailsform.CompanyName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Company Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConsigneeMobile),
      expression: "ConsigneeMobile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:10'),
      expression: "'required|numeric|digits:10'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ConsigneeMobile",
      "id": "Mobile",
      "placeholder": "Enter Mobile Number",
      "maxlength": "10",
      "pattern": "^[6789](\\d)(?!\\1+$){3,}\\d{8}$"
    },
    domProps: {
      "value": (_vm.ConsigneeMobile)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConsigneeMobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ConsigneeMobile')),
      expression: "errors.has('consigneedetailsform.ConsigneeMobile')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.ConsigneeMobile')))]), _vm._v(" "), (_vm.errors.first('consigneedetailsform.ConsigneeMobile') == 'The ConsigneeMobile field format is invalid') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Number Should Start with 6,7,8 or 9")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignee POC")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-badge' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ATTN),
      expression: "ATTN"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ATTN",
      "id": "ATTN",
      "placeholder": "Enter Consignee POC",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.ATTN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ATTN = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ATTN')),
      expression: "errors.has('consigneedetailsform.ATTN')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Consignee POC field is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Telephone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConsigneeTelephone),
      expression: "ConsigneeTelephone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ConsigneeTelephone",
      "id": "ConsigneeTelephone",
      "placeholder": "Enter Telephone",
      "maxlength": "12",
      "minlength": "6"
    },
    domProps: {
      "value": (_vm.ConsigneeTelephone)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConsigneeTelephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ConsigneeTelephone')),
      expression: "errors.has('consigneedetailsform.ConsigneeTelephone')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.ConsigneeTelephone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Email")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConsigneeEmail),
      expression: "ConsigneeEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ConsigneeEmail",
      "id": "ConsigneeEmail",
      "placeholder": "Enter Email",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.ConsigneeEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConsigneeEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ConsigneeEmail')),
      expression: "errors.has('consigneedetailsform.ConsigneeEmail')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.ConsigneeEmail')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("GST No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-asterisk' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CSTTINNo),
      expression: "CSTTINNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validate_gst'),
      expression: "'required|validate_gst'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "CSTTINNo",
      "id": "CSTTINNo",
      "placeholder": "Enter GST No"
    },
    domProps: {
      "value": (_vm.CSTTINNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CSTTINNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "gstBlock"
    }
  }, [_vm._v("Note: Allowed GST Format 00XXXXX0000X1ZZ.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.CSTTINNo')),
      expression: "errors.has('consigneedetailsform.CSTTINNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter valid format of GST Number")])], 1), _vm._v(" "), (_vm.SelfCollectByClient == false) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConsigneeAddress),
      expression: "ConsigneeAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "ConsigneeAddress",
      "name": "ConsigneeAddress",
      "placeholder": "Address ",
      "maxlength": "255",
      "disabled": _vm.AddNewConsigneeFlag == false
    },
    domProps: {
      "value": (_vm.ConsigneeAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConsigneeAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ConsigneeAddress')),
      expression: "errors.has('consigneedetailsform.ConsigneeAddress')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.ConsigneeAddress')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Comments")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consingneecomments),
      expression: "consingneecomments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('consingneecomments')
    },
    attrs: {
      "name": "consingneecomments",
      "id": "consingneecomments",
      "maxlength": "500",
      "placeholder": "Enter Comments"
    },
    domProps: {
      "value": (_vm.consingneecomments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consingneecomments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.consingneecomments')),
      expression: "errors.has('consigneedetailsform.consingneecomments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter comment")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      },
      "click": _vm.checkConsigneeDetailsValidation
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ShipmentDetails",
      "id": "chck3",
      "disabled": _vm.subtabdisabledflag
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Change Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "shipmentdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Total Shipment Declared Value (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-inr' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TotalShipmentValue),
      expression: "TotalShipmentValue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "title": "Total Shipment Declared Value (INR)",
      "name": "Total Shipment Declared Value",
      "id": "TotalShipmentValue",
      "placeholder": "Enter Total Shipment Value",
      "min": 1
    },
    domProps: {
      "value": (_vm.TotalShipmentValue)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TotalShipmentValue = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('shipmentdetailsform.Total Shipment Declared Value') == 'The Total Shipment Declared Value field must be numeric and may contain decimal points') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Total Shipment Declared Value field is required ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('shipmentdetailsform.Total Shipment Declared Value') && _vm.errors.first('shipmentdetailsform.Total Shipment Declared Value') != 'The Total Shipment Declared Value field must be numeric and may contain decimal points') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('shipmentdetailsform.Total Shipment Declared Value')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Reference Number")]), (_vm.referencemandatory) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReferenceNumber),
      expression: "ReferenceNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.referencemandatory
      }),
      expression: "{required: referencemandatory}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "title": "Reference Number",
      "name": "ReferenceNumber",
      "id": "ReferenceNumber",
      "placeholder": "Enter Reference Number",
      "maxlength": "200",
      "disabled": _vm.editBasicDetailsflag && _vm.editShipmentValue
    },
    domProps: {
      "value": (_vm.ReferenceNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReferenceNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('shipmentdetailsform.ReferenceNumber') == 'Reference Number field must be numeric and may contain decimal points') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Reference Number field is required ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('shipmentdetailsform.ReferenceNumber') && _vm.errors.first('shipmentdetailsform.ReferenceNumber') != 'The Reference Number field must be number') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('shipmentdetailsform.ReferenceNumber')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Reference Number")]), (_vm.clientreferencemandatory) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClientReferenceNumber),
      expression: "ClientReferenceNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.clientreferencemandatory
      }),
      expression: "{required:clientreferencemandatory }"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "title": "Client Reference Number",
      "name": "Client Reference Number",
      "id": "Client Reference Number",
      "placeholder": "Enter Client Reference Number",
      "maxlength": "200",
      "disabled": _vm.editBasicDetailsflag && _vm.editShipmentValue
    },
    domProps: {
      "value": (_vm.ClientReferenceNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ClientReferenceNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('shipmentdetailsform.Client Reference Number') == 'The Client Reference Number field must be numeric and may contain decimal points') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Client Reference Number field is required ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('shipmentdetailsform.Client Reference Number') && _vm.errors.first('shipmentdetailsform.Client Reference Number') != 'The Client Reference Number field must be number') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('shipmentdetailsform.Client Reference Number')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Comments")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentdetailcomments),
      expression: "shipmentdetailcomments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentdetailcomments')
    },
    attrs: {
      "name": "shipmentdetailcomments",
      "id": "shipmentdetailcomments",
      "placeholder": "Enter Comments",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.shipmentdetailcomments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentdetailcomments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.shipmentdetailcomments')),
      expression: "errors.has('shipmentdetailsform.shipmentdetailcomments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter comment")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      },
      "click": _vm.checkShipmentTotalValidation
    }
  }, [_vm._v("Save")])])])])])])])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3455c396","hasScoped":true}!./src/modules/utility/views/updateBookingDetails/changebasicdetails/updateBookingDetails.component.html
// module id = 2184
// module chunks = 3